export const getNudgeDeltaFromArrowKey = (key, shiftKey) => {
  const step = shiftKey ? 10 : 1;
  switch (key) {
    case 'ArrowLeft':
      return { dx: -step, dy: 0 };
    case 'ArrowRight':
      return { dx: step, dy: 0 };
    case 'ArrowUp':
      return { dx: 0, dy: -step };
    case 'ArrowDown':
      return { dx: 0, dy: step };
    default:
      return null;
  }
};

const buildNudgeAnnotationPayload = (annotation, dx, dy) => {
  if (!annotation?.id || (dx === 0 && dy === 0)) {
    return null;
  }

  if (Array.isArray(annotation.points) && annotation.points.length >= 2) {
    return {
      id: annotation.id,
      points: annotation.points.map((value, index) =>
        value + (index % 2 === 0 ? dx : dy),
      ),
    };
  }

  if (typeof annotation.x === 'number' && typeof annotation.y === 'number') {
    return {
      id: annotation.id,
      x: annotation.x + dx,
      y: annotation.y + dy,
    };
  }

  return null;
};

export default buildNudgeAnnotationPayload;
